import { setTrackView, useTracking } from '@vfit/shared/data-access';
import { useQueryClient } from 'react-query';
import { getTagging, getUserInfo } from '../../checkout.utils';
import { withAnimationDelay } from '../../hoc/withAnimationDelay';

const TaggingComponent = () => {
  const queryClient = useQueryClient();
  const taggingMobile = getTagging('document', 'mobile', queryClient);
  const { trackView } = useTracking({
    event: ['checkout_step2'],
    event_label: 'document',
    opts: taggingMobile?.opts,
    cartProduct: taggingMobile?.trackingProduct,
    pageProduct: taggingMobile?.pageProductsInfo,
    visitorTrackingOpts: getUserInfo(),
  });
  setTrackView(trackView);

  return null;
};

const TaggingDocumentIdCard = withAnimationDelay()(TaggingComponent);

export default TaggingDocumentIdCard;
